var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrightness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V4C12.75 4.41421 12.4142 4.75 12 4.75C11.5858 4.75 11.25 4.41421 11.25 4V2C11.25 1.58579 11.5858 1.25 12 1.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.25C12.4142 19.25 12.75 19.5858 12.75 20V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V20C11.25 19.5858 11.5858 19.25 12 19.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.25C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H4C4.41421 12.75 4.75 12.4142 4.75 12C4.75 11.5858 4.41421 11.25 4 11.25H2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 12C19.25 11.5858 19.5858 11.25 20 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H20C19.5858 12.75 19.25 12.4142 19.25 12Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45925 4.39862C5.16636 4.10573 4.69149 4.10573 4.39859 4.39862C4.1057 4.69152 4.1057 5.16639 4.39859 5.45928L5.81281 6.8735C6.1057 7.16639 6.58057 7.16639 6.87347 6.8735C7.16636 6.5806 7.16636 6.10573 6.87347 5.81284L5.45925 4.39862Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1265 17.1264C17.4194 16.8335 17.8943 16.8335 18.1872 17.1264L19.6014 18.5406C19.8943 18.8335 19.8943 19.3084 19.6014 19.6013C19.3085 19.8942 18.8336 19.8942 18.5407 19.6013L17.1265 18.1871C16.8336 17.8942 16.8336 17.4193 17.1265 17.1264Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39859 18.5406C4.1057 18.8335 4.1057 19.3084 4.39859 19.6013C4.69149 19.8942 5.16636 19.8942 5.45925 19.6013L6.87347 18.1871C7.16636 17.8942 7.16636 17.4193 6.87347 17.1264C6.58057 16.8335 6.1057 16.8335 5.81281 17.1264L4.39859 18.5406Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1265 6.8735C16.8336 6.58061 16.8336 6.10573 17.1265 5.81284L18.5407 4.39863C18.8336 4.10573 19.3085 4.10573 19.6014 4.39863C19.8943 4.69152 19.8943 5.16639 19.6014 5.45929L18.1872 6.8735C17.8943 7.16639 17.4194 7.16639 17.1265 6.8735Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 8.94025 8.29027 6.41546 11.25 6.04639V10.984C11.2498 10.995 11.2498 11.0059 11.25 11.0169V14.984C11.2498 14.995 11.2498 15.0059 11.25 15.0169V17.9536C8.29027 17.5845 6 15.0597 6 12Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8987 13.1035C17.4255 15.6491 15.3451 17.63 12.75 17.9536V15.4799L17.8987 13.1035Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9721 11.4176C17.9009 10.6785 17.6956 9.97862 17.3809 9.34253L12.75 11.4799V13.8278L17.9721 11.4176Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.04639C14.2594 6.23461 15.5947 6.98352 16.541 8.07812L12.75 9.82779V6.04639Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightness);
export default __webpack_public_path__ + "static/media/brightness.92bf7038592420670f8d801c621374db.svg";
export { ForwardRef as ReactComponent };